/** @module csi/widget/Select */
define([
	"dojo/_base/declare",
	"dijit/form/Select",
	"./_HasDropDownMixin"
], function(declare,Select,_HasDropDownMixin) {

	return declare([Select,_HasDropDownMixin], {});
});